module.exports = __webpack_public_path__ + "img/chip04.baf1cff7.png";